import { ReactNode, useContext } from "react";
import { ChatOptionsContext } from "../contexts/ChatOptionsContext";
import { RAGSourcesContext } from "../contexts/RAGSourcesContext";
import { PromptTemplatesContext } from "../contexts/PromptTemplatesContext";
import { UserInfoContext } from "../contexts/UserInfoContext";
import { Loading } from "../Loading";

interface AuthenticatedLoadingWrapperProps {
  children: ReactNode;
}

export default function AuthenticatedLoadingWrapper({
  children,
}: AuthenticatedLoadingWrapperProps) {
  const chatOptionsContext = useContext(ChatOptionsContext);
  const ragSourcesContext = useContext(RAGSourcesContext);
  const promptTemplatesContext = useContext(PromptTemplatesContext);
  const userInfoContext = useContext(UserInfoContext);

  // Check if any context is still loading
  const isLoading = [chatOptionsContext, ragSourcesContext, promptTemplatesContext, userInfoContext]
    .some(context => context?.loading);

  if (isLoading) {
    return <Loading contexts={[chatOptionsContext, ragSourcesContext, promptTemplatesContext, userInfoContext].filter(Boolean)} />;
  }

  return <>{children}</>;
}
